import React, { Dispatch, SetStateAction, useState } from 'react';

interface ChatbotContextValues {
    initialized: boolean;
    /**
     * Boolean indicating if the chatbot should be enabled for the current user.
     * False when the user is not part of the chat variant group.
     */
    enabled: boolean;

    /**
     * Display the chat interface for the user to interact with.
     */
    showChat: boolean;

    /**
     * Set the state of the chat interface.
     */
    setShowChat: Dispatch<SetStateAction<boolean>>;
}

export const ChatbotContext = React.createContext<ChatbotContextValues>({
    initialized: false,
    enabled: false,
    showChat: false,
    setShowChat: (value) => {},
});

export const ChatbotContextProvider: React.FunctionComponent<{
    enabled?: boolean;
    children?: React.ReactNode;
}> = ({ enabled, children }) => {
    const [showChat, setShowChat] = useState(false);
    const initialValues: ChatbotContextValues = {
        initialized: true,
        enabled: !!enabled,
        setShowChat,
        showChat,
    };

    return <ChatbotContext.Provider value={initialValues}>{children}</ChatbotContext.Provider>;
};
